/* eslint-disable no-debugger */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff, FiMail, FiLock } from 'react-icons/fi';
import AppButton from '../../shared/components/app-button/AppButton';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import { doLoginApi, getAppConstants } from '../../api/loginApi';
import {
  setStringInLs,
  setDataInLS,
} from '../../shared/helper-utils/localStorage';
import {
  APP_LOGGEDIN_AGENTID,
  NAVIGATION_ROUTES,
} from '../../shared/constants/Constants';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import ForgotPassword from './ForgotPassword';
import AppModal from '../../shared/components/app-modal/AppModal';
import {
  APP_CONFIG,
  APP_USER_AUTH,
  APP_USER_PROFILE,
} from '../../saas/AppStorageStaticNames';
import './LoginVaya.scss';

function LoginVaya() {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState('login');
  const [alert, setAlert] = useState(undefined);
  const [validationError, setValidationError] = useState(false);
  const [login, setLogin] = useState({
    agent_userid: '',
    agent_password: '',
    opid: 'AU001',
    usertype: 'reactclient',
    agencycode: '',
    responseformat: 'JSON',
    securetoken: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const getSecureTocken = async () => {
    setIsLoading(true);
    try {
      const response = await FingerprintJS.load();
      const result = await response.get();
      setLogin((prev) => ({ ...prev, securetoken: result.visitorId }));
    } catch (error) {
      setLogin((prev) => ({ ...prev, securetoken: '' }));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getSecureTocken();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setLogin((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!login.agent_userid || !login.agent_password) {
      setValidationError(true);
      return;
    }
    setValidationError(false);
    setIsLoading(true);
    const loginResponse = await doLoginApi(login);
    setIsLoading(false);
    if (loginResponse?.ApiStatus?.StatusCode !== 200) {
      setAlert({
        variant: 'error',
        title: 'Login Failed',
        description: loginResponse?.ApiStatus?.Message,
      });
    } else {
      const { Result } = loginResponse.ApiStatus;
      if (Result === 'OTPSENT') {
        setShowOtpModal(true);
      } else {
        const profileInfo = Result.split('@@@');
        const profile = {
          agentId: profileInfo[0],
          profileId: profileInfo[1],
          title: profileInfo[2],
          firstName: profileInfo[3],
          lastName: profileInfo[4],
          systemRoleId: profileInfo[5],
          companyName: profileInfo[6],
        };
        setDataInLS(APP_USER_PROFILE, profile);
        setStringInLs(APP_LOGGEDIN_AGENTID, profile.agentId);
        setStringInLs(APP_USER_AUTH, loginResponse.ApiStatus.TransactionStatus);
        setIsLoading(true);
        const response = await getAppConstants();
        if (response?.Root?.Status === 'OK') {
          const { ConfigSetting } = response.Root.Result.ConfigSettings;
          setDataInLS(APP_CONFIG, ConfigSetting);
        }
        setIsLoading(false);
        window.location.href = NAVIGATION_ROUTES.LANDING;
      }
    }
  };

  return (
    <>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}

      {showForm === 'login' ? (
        <div className="lv-form">
          <h2 className="lv-title">Login to your account</h2>

          {/* Agency ID */}
          <div className="lv-field">
            <span className="lv-label">
              User ID <span className="lv-required">*</span>
            </span>
            <div
              className={`lv-input-wrap${
                validationError && !login.agent_userid
                  ? ' lv-input-wrap--error'
                  : ''
              }`}
            >
              <FiMail className="lv-icon" size={18} />
              <input
                id="lv_userid"
                name="agent_userid"
                type="text"
                className="lv-input"
                placeholder="Enter agency ID or email"
                value={login.agent_userid}
                onChange={handleChange}
                autoComplete="username"
              />
            </div>
            {validationError && !login.agent_userid && (
              <span className="lv-error-text">Agency ID is required</span>
            )}
          </div>

          {/* Password */}
          <div className="lv-field">
            <span className="lv-label">
              Password <span className="lv-required">*</span>
            </span>
            <div
              className={`lv-input-wrap${
                validationError && !login.agent_password
                  ? ' lv-input-wrap--error'
                  : ''
              }`}
            >
              <FiLock className="lv-icon" size={18} />
              <input
                id="lv_password"
                name="agent_password"
                type={showPassword ? 'text' : 'password'}
                className="lv-input"
                placeholder="Enter password"
                value={login.agent_password}
                onChange={handleChange}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="lv-eye-btn"
                onClick={() => setShowPassword((p) => !p)}
                tabIndex={-1}
              >
                {showPassword ? <FiEye size={18} /> : <FiEyeOff size={18} />}
              </button>
            </div>
            {validationError && !login.agent_password && (
              <span className="lv-error-text">Password is required</span>
            )}
          </div>

          {/* Forgot password */}
          <div className="lv-forgot">
            Forgot Password?{' '}
            <button
              type="button"
              className="lv-link"
              onClick={() => setShowForm('forgot')}
            >
              Reset Here
            </button>
          </div>

          {/* Submit */}
          <button type="button" className="lv-submit" onClick={handleSubmit}>
            Login
          </button>

          {/* Sign up */}
          <div className="lv-signup">
            Don&apos;t have an account?{' '}
            <button
              type="button"
              className="lv-link"
              onClick={() => navigate(NAVIGATION_ROUTES.AGENT_REGISTRATION)}
            >
              Sign Up
            </button>
          </div>
        </div>
      ) : (
        <ForgotPassword
          onShowForm={setShowForm}
          onLoading={setIsLoading}
          onAlert={setAlert}
        />
      )}

      {showOtpModal && (
        <AppModal
          modalTitle="Enter OTP Received on Email"
          showCloseButton
          onModalClose={() => setShowOtpModal(false)}
        >
          <div className="d-flex gap-2">
            <AppTextInput
              onChange={handleChange}
              value={login.otp}
              name="otp"
              placeholderText=""
              label="OTP"
            />
            <AppButton btnText="Done" onClick={handleSubmit} />
          </div>
        </AppModal>
      )}
    </>
  );
}

export default LoginVaya;
